import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { Badge, Button } from "src/components";

// Create a column helper
const columnHelper = createColumnHelper();

export const getClusterMasterColumns = (dependencies: string[], onEdit: any) => {
  return useMemo(
    () => [
      columnHelper.accessor("cluster_code", {
        cell: (info) => info.getValue(),
        header: () => "Cluster code",
        enableSorting: true,
        size: 101,
      }),
      columnHelper.accessor("cluster_name", {
        cell: (info) => info.getValue(),
        header: () => "Cluster Name",
        enableSorting: true,
        size: 101,
      }),
      columnHelper.accessor("active_status", {
        cell: (info) => {
          const value = info.getValue();
          const isActive = value === "Y";
          return isActive ? <Badge variant="success">True</Badge> : <Badge>False</Badge>;
        },
        header: () => "Status",
        enableSorting: true,
        size: 101,
      }),

      columnHelper.accessor("edit", {
        cell: (info) => (
          <Button className="border" onClick={() => onEdit(info.row.original)}>
            Edit
          </Button>
        ),
        header: () => "Status",
        enableSorting: true,
        size: 101,
      }),
    ],
    [...dependencies]
  );
};
